import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { AcceptInvitation } from '../../organisms/AcceptInvitation';

const acceptInvitationSearchSchema = z.object({
  token: z.string().optional(),
  email: z.string().optional(),
});

export const Route = createFileRoute('/_unauthenticated/accept-invitation')({
  component: AcceptInvitation,
  validateSearch: (search) => acceptInvitationSearchSchema.parse(search),
});
